// extracted by mini-css-extract-plugin
export default {"plusMinus":"styles_plusMinus__ucdrn","active":"styles_active__YKeXw"};